import {
  createHookStore,
  createUseSelector,
  STORE_NAMES
} from '@namespace/helpers-store';

export const initialState = {
  expressDay: {},
  isBetsFetching: false,
  bets: { ids: [], data: {} },
  casinoBetsHistory: [],
  details: {},
  multiSystemDetails: {},
  roundData: {},
  gameRounds: [],
  filterData: { gamesName: [], providersName: [] },
  gameRoundsName: { gameName: '', providerName: '' },
  providersName: [],
  isEmptyBets: false,
  isShowMoreRounds: false,
  betsCount: 0
};

export const useBetsStore = createHookStore(STORE_NAMES.BETS, initialState);

export const useBetsSelector = createUseSelector(useBetsStore);
